const data = {
  navLinks: [
    {
      title: "About Setu",
      cta: "/about",
      eventName: "ABOUT_SETU_CLICKED",
    },
    {
      title: "Our Team",
      cta: "/our_team",
      eventName: "OUR_TEAM_BUTTON_CLICKED",
    },
    {
      title: "Blogs",
      cta: "/blogs",
      eventName: "BLOGS_BUTTON_CLICKED",
    },
    {
      title: "FAQs",
      cta: "/faqs",
      eventName: "FAQS_BUTTON_CLICKED",
    },
  ],
};

export default data;
